module.exports = __webpack_public_path__ + "img/apaym-1.b3378be0.png";